type CountCellProps = {
  array: any[] | null | undefined,
  fallbackValue?: number
};

export const CountCell = ({ array, fallbackValue = 0 }: CountCellProps) => {
  const count = Array.isArray(array) ? array.length : fallbackValue;
  return <span className="text-gray-700">{count}</span>;
};
